import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const WhatsAppButton: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);

  // Animação de destaque ao carregar a página após 3 segundos
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setHasAnimated(true);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center">
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, x: 20, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 20, scale: 0.8 }}
            transition={{ duration: 0.2 }}
            className="mr-4 bg-white text-gray-800 rounded-lg py-2 px-4 shadow-xl text-sm font-medium relative"
          >
            Fale conosco no WhatsApp
            <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 rotate-45 w-3 h-3 bg-white" />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        className="flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full p-4 shadow-xl hover:shadow-green-500/20 transition-shadow"
        aria-label="Contato via WhatsApp"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onHoverStart={() => setShowTooltip(true)}
        onHoverEnd={() => setShowTooltip(false)}
        animate={hasAnimated ? {} : {
          scale: [1, 1.2, 1],
          rotate: [0, 10, -10, 0],
        }}
        transition={{
          duration: 0.6,
          repeat: hasAnimated ? 0 : 1,
        }}
        onClick={() => {
          // Mensagem predefinida para o WhatsApp
          const message = "Olá, Dra. Lidiane!\nEncontrei seu contato pelo site e gostaria de solicitar algumas informações: Estou enfrentando um problema com minha conta";
          
          // Abrir WhatsApp com a mensagem
          window.open(`https://wa.me/5581993507689?text=${encodeURIComponent(message)}`, '_blank');
        }}
      >
        <motion.div
          animate={{ rotate: [0, 15, -15, 0] }}
          transition={{ 
            repeat: Infinity, 
            repeatType: 'reverse', 
            duration: 1.5, 
            repeatDelay: 2 
          }}
        >
          <MessageCircle size={28} />
        </motion.div>
        
        <motion.span 
          className="absolute top-0 right-0 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-xs font-bold border-2 border-white"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: 'spring',
            stiffness: 500,
            damping: 15,
            delay: 1
          }}
        >
          1
        </motion.span>
      </motion.button>
    </div>
  );
};

export default WhatsAppButton;